module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bc45b073cd2fc0c2265374bdb4e05d67.svg";